import { render, staticRenderFns } from "./product-media.vue?vue&type=template&id=295c54f2&scoped=true&"
import script from "./product-media.vue?vue&type=script&lang=js&"
export * from "./product-media.vue?vue&type=script&lang=js&"
import style0 from "./product-media.vue?vue&type=style&index=0&id=295c54f2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295c54f2",
  null
  
)

export default component.exports